import React from 'react'
import classes from './DeleteModal.module.scss'
import cx from "classnames";


const DeleteModal = (props: any) => {
    const { setModal, modal, handleDelete } = props
    return (
        <div className={classes.ModalBackground}>
            <div className={classes.ModalContent}>
                <div style={{ flex: "1", gap: '5px', display: 'flex', flexDirection: 'column' }}>
                    {/* <div className={classes.ModalHead}>
                        <button className={classes.CloseButton}>
                            <Close style={{ margin: "0px", color: "#B0BBCB", transform: "scale(0.8)" }} />
                        </button>
                    </div> */}
                    <p className={cx(classes.poppins)}>
                        Remove Item
                    </p>
                    <p className={cx(classes.poppins)} style={{ fontWeight: 500, fontSize: '16px' }}>
                        Are you sure you want to remove item from the cart
                    </p>
                    <div className={classes.clearfix}>
                        <button type="button" className={classes.cancelbtn} onClick={() => setModal('')} >Cancel</button>
                        <button type="button" className={classes.deletebtn} onClick={() => handleDelete(modal)}>Delete</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteModal